import { render, staticRenderFns } from "./ArtificialInsemination.vue?vue&type=template&id=0994178c&scoped=true&"
import script from "./ArtificialInsemination.vue?vue&type=script&lang=js&"
export * from "./ArtificialInsemination.vue?vue&type=script&lang=js&"
import style0 from "./ArtificialInsemination.vue?vue&type=style&index=0&id=0994178c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0994178c",
  null
  
)

export default component.exports